import React, { Component } from 'react'
import PropTypes from 'prop-types'
import Button from 'semantic-ui-react/dist/commonjs/elements/Button'
import { connect } from 'react-redux'

import { printReceiptAction } from '../../redux/reducers/app/actions'

class PrintReceiptButton extends Component {
  handleClick = () => {
    const { printReceipt, sale_id } = this.props
    printReceipt(sale_id)
  }

  render() {
    return (
      <Button
        style={{fontSize:'9pt'}}
        content="Receipt"
        onClick={this.handleClick}
      />
    )
  }
}

PrintReceiptButton.propTypes = {
  // The following props from redux:
  printReceipt: PropTypes.func.isRequired,
  sale_id: PropTypes.string.isRequired,
}

const mapState = state => ({
  sale_id: state.app.activeSale._id,
})
const mapDispatch = dispatch => ({
  printReceipt: (sale_id) => dispatch(printReceiptAction(sale_id)),
})

export default connect(mapState, mapDispatch)(PrintReceiptButton)
